import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  constructor(private readonly http: HttpClient) {}

  getQuotes = (payload: any) => {
    return this.http.post(
      `${environment.api.baseAddress}/api/cmquote/quote`,
      payload
    );
  };

  generatePDF = (payload: any) => {
    return this.http.post(
      `${environment.api.baseAddress}/api/cmquote/download`,
      payload
    );
  };

  logTruckNotListed = () => {
    return this.http.post(
      `${environment.api.baseAddress}/api/cmquote/logTruckNotListed`,
      null
    );
  };
}
